import { getVisitorId } from './siteTracking';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/blog/views`;

export const TRENDING_THRESHOLD = 10;

export const fetchAllViews = async () => {
  const res = await fetch(API);
  return res.ok ? res.json() : {};
};

export const fetchArticleViews = async (slug) => {
  const res = await fetch(`${API}/${slug}`);
  return res.ok ? (await res.json()).views : 0;
};

export const recordArticleView = async (slug) => {
  const res = await fetch(`${API}/${slug}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ visitor_id: getVisitorId() })
  });
  return res.ok ? (await res.json()).views : null;
};

export const formatReads = (views) => `${views.toLocaleString()} ${views === 1 ? 'read' : 'reads'}`;
